function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1976(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 20.78,
    height: 11.02,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 0.8476923076923076
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 5.51
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 11.02,
    width: 20.78,
    height: 11.22,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.87
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 16.63
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 22.24,
    width: 20.78,
    height: 12.68,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.8114285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 28.58
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 34.93,
    width: 20.78,
    height: 15.86,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.5859999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 42.86
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 50.79,
    width: 20.78,
    height: 15.96,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.2800000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 58.769999999999996
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 66.74,
    width: 20.78,
    height: 16.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8233333333333337
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 75.21
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 83.68,
    width: 20.78,
    height: 17.33,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 92.345
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 101.01,
    width: 20.78,
    height: 20.02,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 111.02000000000001
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 121.03,
    width: 20.78,
    height: 23.61,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.195
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 132.835
  }, "\n        Long\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.64,
    width: 20.78,
    height: 23.64,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.156000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 156.45999999999998
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 168.29,
    width: 20.78,
    height: 23.79,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 180.185
  }, "\n        Lanier\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 192.08,
    width: 20.78,
    height: 25.87,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 205.01500000000001
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 217.95,
    width: 20.78,
    height: 27.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 231.82999999999998
  }, "\n        Wheeler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 245.7,
    width: 20.78,
    height: 28.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 259.835
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 273.97,
    width: 20.78,
    height: 28.96,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 288.45000000000005
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 302.94,
    width: 20.78,
    height: 29.5,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 317.69
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 332.43,
    width: 20.78,
    height: 30.74,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 347.8
  }, "\n        Atkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 363.17,
    width: 20.78,
    height: 32.43,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 379.385
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 395.6,
    width: 20.78,
    height: 32.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.156000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 411.925
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 428.25,
    width: 20.78,
    height: 32.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 444.625
  }, "\n        Treutlen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 461,
    width: 20.78,
    height: 32.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 477.39
  }, "\n        Candler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 493.79,
    width: 20.78,
    height: 33.12,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 510.35
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 526.91,
    width: 20.78,
    height: 33.28,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 543.55
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 560.19,
    width: 20.78,
    height: 33.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4633333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 577.0550000000001
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 593.93,
    width: 20.78,
    height: 34.8,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.968571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 611.3299999999999
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 628.73,
    width: 20.78,
    height: 35.49,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 646.475
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 664.22,
    width: 20.78,
    height: 35.78,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 10.39,
    y: 682.11
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 0,
    width: 26.04,
    height: 28.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.604
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 33.8,
    y: 14.38
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.81,
    y: 0,
    width: 27.68,
    height: 28.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.536
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 60.650000000000006,
    y: 14.38
  }, "\n        Evans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 74.49,
    y: 0,
    width: 27.75,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.9642857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 88.365,
    y: 14.38
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.24,
    y: 0,
    width: 28.71,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.785
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.595,
    y: 14.38
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.95,
    y: 0,
    width: 29.1,
    height: 28.76,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.793333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 145.5,
    y: 14.38
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 160.05,
    y: 0,
    width: 29.26,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 174.68,
    y: 14.38
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 189.31,
    y: 0,
    width: 29.59,
    height: 28.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.793333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 204.105,
    y: 14.38
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 218.9,
    y: 0,
    width: 29.96,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.752000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.88,
    y: 14.38
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 248.86,
    y: 0,
    width: 30.88,
    height: 28.76,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 264.3,
    y: 14.38
  }, "\n        Brantley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 279.74,
    y: 0,
    width: 31.03,
    height: 28.76,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.8760000000000003
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.255,
    y: 14.38
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 310.77,
    y: 0,
    width: 31.19,
    height: 28.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.19
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 326.365,
    y: 14.38
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 341.97,
    y: 0,
    width: 31.22,
    height: 28.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.793333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 357.58000000000004,
    y: 14.38
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.19,
    y: 0,
    width: 31.64,
    height: 28.76,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.752000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.01,
    y: 14.38
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 404.82,
    y: 0,
    width: 32.02,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.752000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 420.83,
    y: 14.38
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.84,
    y: 0,
    width: 32.08,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.595
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 452.88,
    y: 14.38
  }, "\n        Seminole\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.92,
    y: 0,
    width: 32.23,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 485.035,
    y: 14.38
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 501.15,
    y: 0,
    width: 32.64,
    height: 28.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 517.47,
    y: 14.38
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 533.79,
    y: 0,
    width: 32.67,
    height: 28.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.752000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 550.125,
    y: 14.38
  }, "\n        Bryan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 566.47,
    y: 0,
    width: 33.03,
    height: 28.76,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.586666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.985,
    y: 14.38
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.5,
    y: 0,
    width: 33.16,
    height: 28.76,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 616.08,
    y: 14.38
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 632.66,
    y: 0,
    width: 33.48,
    height: 28.76,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.793333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 649.4,
    y: 14.38
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 666.14,
    y: 0,
    width: 33.86,
    height: 28.76,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.1085714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 683.0699999999999,
    y: 14.38
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 28.76,
    width: 32.6,
    height: 30.13,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.76625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 43.825
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 58.89,
    width: 32.6,
    height: 30.42,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0840000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 74.1
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 89.3,
    width: 32.6,
    height: 30.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 104.64999999999999
  }, "\n        Bacon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 120.01,
    width: 32.6,
    height: 30.7,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 135.36
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 150.71,
    width: 32.6,
    height: 31.09,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.109
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 166.255
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 181.8,
    width: 32.6,
    height: 31.1,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.183333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 197.35000000000002
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 212.91,
    width: 32.6,
    height: 31.8,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.36
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 228.81
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 244.71,
    width: 32.6,
    height: 32.58,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.43
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 261
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 277.29,
    width: 32.6,
    height: 32.64,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 293.61
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 309.94,
    width: 32.6,
    height: 32.73,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 326.305
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 342.67,
    width: 32.6,
    height: 33.52,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 359.43
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 376.18,
    width: 32.6,
    height: 34.35,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 393.355
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 410.53,
    width: 32.6,
    height: 35.05,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 428.05499999999995
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 445.58,
    width: 32.6,
    height: 35.84,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.6222222222222222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 463.5
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 481.42,
    width: 32.6,
    height: 36.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 499.48
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 517.54,
    width: 32.6,
    height: 36.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.433333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 535.66
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 553.78,
    width: 32.6,
    height: 36.4,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.6571428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 571.98
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 590.18,
    width: 32.6,
    height: 36.49,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.15
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 608.425
  }, "\n        Cook\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 626.67,
    width: 32.6,
    height: 36.59,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.5200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 644.9649999999999
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.78,
    y: 663.26,
    width: 32.6,
    height: 36.74,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 37.08,
    y: 681.63
  }, "\n        Bleckley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 28.76,
    width: 32.29,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.458
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 69.525,
    y: 47.595
  }, "\n        Lamar\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 85.67,
    y: 28.76,
    width: 32.45,
    height: 37.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.1125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 101.89500000000001,
    y: 47.595
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118.12,
    y: 28.76,
    width: 32.45,
    height: 37.67,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.49
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 134.345,
    y: 47.595
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.57,
    y: 28.76,
    width: 33.04,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 167.09,
    y: 47.595
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.62,
    y: 28.76,
    width: 33.38,
    height: 37.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.5633333333333335
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 200.31,
    y: 47.595
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 217,
    y: 28.76,
    width: 33.42,
    height: 37.67,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 233.71,
    y: 47.595
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 250.42,
    y: 28.76,
    width: 35.08,
    height: 37.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.016
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 267.96,
    y: 47.595
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.5,
    y: 28.76,
    width: 35.1,
    height: 37.67,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.014285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.05,
    y: 47.595
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 320.6,
    y: 28.76,
    width: 35.1,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.0200000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 338.15000000000003,
    y: 47.595
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.7,
    y: 28.76,
    width: 35.17,
    height: 37.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.861666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.28499999999997,
    y: 47.595
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 390.88,
    y: 28.76,
    width: 35.91,
    height: 37.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.984999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 408.835,
    y: 47.595
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 426.79,
    y: 28.76,
    width: 37.08,
    height: 37.67,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.297142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 445.33000000000004,
    y: 47.595
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.87,
    y: 28.76,
    width: 38.29,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 483.015,
    y: 47.595
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 502.15,
    y: 28.76,
    width: 39.11,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.278333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 521.7049999999999,
    y: 47.595
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.27,
    y: 28.76,
    width: 39.16,
    height: 37.67,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.278333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 560.85,
    y: 47.595
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.42,
    y: 28.76,
    width: 39.33,
    height: 37.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.185555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 600.0849999999999,
    y: 47.595
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 619.75,
    y: 28.76,
    width: 39.84,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 639.67,
    y: 47.595
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 659.59,
    y: 28.76,
    width: 40.41,
    height: 37.67,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 679.7950000000001,
    y: 47.595
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 66.43,
    width: 41.17,
    height: 37.09,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.121111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 84.97500000000001
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 103.53,
    width: 41.17,
    height: 37.25,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 122.155
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 140.77,
    width: 41.17,
    height: 38.38,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 159.96
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 179.15,
    width: 41.17,
    height: 38.95,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.790000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 198.625
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 218.1,
    width: 41.17,
    height: 39.69,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 237.945
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 257.78,
    width: 41.17,
    height: 39.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.96375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 277.635
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 297.49,
    width: 41.17,
    height: 40.4,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 317.69
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 337.89,
    width: 41.17,
    height: 41.28,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.234
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 358.53
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 379.17,
    width: 41.17,
    height: 41.91,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.234
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 400.125
  }, "\n        Peach\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 421.08,
    width: 41.17,
    height: 44.45,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.2925
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 443.305
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 465.53,
    width: 41.17,
    height: 44.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.117
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 487.98999999999995
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 510.45,
    width: 41.17,
    height: 46.29,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.861666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 533.595
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 556.74,
    width: 41.17,
    height: 46.96,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.5744444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 580.22
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 603.7,
    width: 41.17,
    height: 47.59,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.14625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 627.495
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 53.38,
    y: 651.29,
    width: 41.17,
    height: 48.71,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.234
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 73.965,
    y: 675.645
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 66.43,
    width: 44.91,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 117.005,
    y: 88.87
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 139.46,
    y: 66.43,
    width: 45.13,
    height: 44.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 162.025,
    y: 88.87
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 184.6,
    y: 66.43,
    width: 45.28,
    height: 44.88,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 207.24,
    y: 88.87
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 229.87,
    y: 66.43,
    width: 45.49,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 252.615,
    y: 88.87
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.36,
    y: 66.43,
    width: 45.63,
    height: 44.88,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.976
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 298.175,
    y: 88.87
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 321,
    y: 66.43,
    width: 45.67,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 343.835,
    y: 88.87
  }, "\n        Barrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 366.67,
    y: 66.43,
    width: 45.79,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 389.565,
    y: 88.87
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 412.46,
    y: 66.43,
    width: 46.07,
    height: 44.88,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.48
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 435.495,
    y: 88.87
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.53,
    y: 66.43,
    width: 46.54,
    height: 44.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 481.79999999999995,
    y: 88.87
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 505.06,
    y: 66.43,
    width: 46.87,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.488
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 528.495,
    y: 88.87
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 551.93,
    y: 66.43,
    width: 48.02,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.986666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 575.9399999999999,
    y: 88.87
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 599.95,
    y: 66.43,
    width: 48.92,
    height: 44.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.411428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 624.4100000000001,
    y: 88.87
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.87,
    y: 66.43,
    width: 51.13,
    height: 44.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.61
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.4350000000001,
    y: 88.87
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 111.31,
    width: 51.85,
    height: 44.56,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.57
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 133.59
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 155.88,
    width: 51.85,
    height: 45.79,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.631666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 178.775
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 201.66,
    width: 51.85,
    height: 45.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.192
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 224.64
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 247.62,
    width: 51.85,
    height: 46.31,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.615714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 270.775
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 293.93,
    width: 51.85,
    height: 47.45,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.8625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 317.65500000000003
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 341.38,
    width: 51.85,
    height: 47.67,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.945
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 365.215
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 389.05,
    width: 51.85,
    height: 49.18,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.1475
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 413.64
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 438.23,
    width: 51.85,
    height: 50.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.341666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 463.255
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 488.28,
    width: 51.85,
    height: 52.05,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.9625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 514.305
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 540.33,
    width: 51.85,
    height: 52.3,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.48125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 566.48
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 592.63,
    width: 51.85,
    height: 53.52,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.4071428571428575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 619.39
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.55,
    y: 646.14,
    width: 51.85,
    height: 53.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.370000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 120.475,
    y: 673.0699999999999
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 111.31,
    width: 48.55,
    height: 57.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.935714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 170.675,
    y: 140.125
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 194.96,
    y: 111.31,
    width: 48.99,
    height: 57.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.165000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 219.455,
    y: 140.125
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.95,
    y: 111.31,
    width: 52.93,
    height: 57.63,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.61625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 270.41499999999996,
    y: 140.125
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 296.88,
    y: 111.31,
    width: 53.16,
    height: 57.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.645
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.46,
    y: 140.125
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 350.04,
    y: 111.31,
    width: 53.69,
    height: 57.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.948333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 376.885,
    y: 140.125
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 403.73,
    y: 111.31,
    width: 54.68,
    height: 57.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.07,
    y: 140.125
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458.41,
    y: 111.31,
    width: 57.06,
    height: 57.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.151428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 486.94000000000005,
    y: 140.125
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 515.47,
    y: 111.31,
    width: 58.36,
    height: 57.63,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.605
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 544.65,
    y: 140.125
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.83,
    y: 111.31,
    width: 60.32,
    height: 57.63,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 14.4075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 603.99,
    y: 140.125
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 634.15,
    y: 111.31,
    width: 65.85,
    height: 57.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.20375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 667.0749999999999,
    y: 140.125
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 168.94,
    width: 66.51,
    height: 59.24,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.462857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 198.56
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 228.18,
    width: 66.51,
    height: 59.91,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.558571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 258.135
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 288.09,
    width: 66.51,
    height: 61.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.206
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 318.60499999999996
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 349.12,
    width: 66.51,
    height: 64.52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.753333333333332
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 381.38
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 413.65,
    width: 66.51,
    height: 67.18,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.501428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 447.24
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 480.83,
    width: 66.51,
    height: 68.94,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.501428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 515.3
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 549.77,
    width: 66.51,
    height: 74.84,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.302000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 587.1899999999999
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 146.4,
    y: 624.6,
    width: 66.51,
    height: 75.4,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.390000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 179.655,
    y: 662.3000000000001
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 145,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 168.94,
    width: 65.83,
    height: 91.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.4575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 245.825,
    y: 214.46
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 146,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 278.74,
    y: 168.94,
    width: 66.04,
    height: 91.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.006666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 311.76,
    y: 214.46
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 147,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.78,
    y: 168.94,
    width: 68.3,
    height: 91.04,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.757142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 378.92999999999995,
    y: 214.46
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 148,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 413.08,
    y: 168.94,
    width: 76.5,
    height: 91.04,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 451.33,
    y: 214.46
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 149,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 489.59,
    y: 168.94,
    width: 84.1,
    height: 91.04,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 531.64,
    y: 214.46
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 150,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 573.69,
    y: 168.94,
    width: 126.31,
    height: 91.04,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.005714285714287
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 636.845,
    y: 214.46
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 151,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 259.98,
    width: 121.01,
    height: 96.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.02125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.415,
    y: 308.065
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 152,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 356.15,
    width: 121.01,
    height: 104.03,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.00375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.415,
    y: 408.16499999999996
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 153,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 460.18,
    width: 121.01,
    height: 116.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.5075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.415,
    y: 518.21
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 154,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 212.91,
    y: 576.23,
    width: 121.01,
    height: 123.77,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 30.2525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 273.415,
    y: 638.115
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 155,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.92,
    y: 259.98,
    width: 151.86,
    height: 124.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 17.715714285714288
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 409.85,
    y: 321.985
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 156,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 485.78,
    y: 259.98,
    width: 214.22,
    height: 124.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 31.0025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 592.89,
    y: 321.985
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 157,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 333.92,
    y: 383.99,
    width: 163.24,
    height: 316.01,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.206666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 415.54,
    y: 541.995
  }, "\n        DeKalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 158,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.16,
    y: 383.99,
    width: 202.84,
    height: 316.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 33.806666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.58,
    y: 541.995
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1976);
export default __webpack_public_path__ + "static/media/1976.b0c15c954f1c597bc944eed9ab737110.svg";
export { ForwardRef as ReactComponent };